module.exports = __webpack_public_path__ + "d01f9bc37d33207f76239796d6b724c2.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/wasistgoldencity4.jpg
// module id = 786
// module chunks = 0